// // dashboard-frontend/src/components/UserUpdatePassword.jsx
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { fetchJSON } from '../api';

// const UserUpdatePassword = () => {
//   const navigate = useNavigate();
//   const [user, setUser] = useState(null);
//   const [currentPassword, setCurrentPassword] = useState('');
//   const [newPassword, setNewPassword] = useState('');

//   useEffect(() => {
//     // Check for a logged-in volunteer or admin user
//     const volunteerStr = localStorage.getItem('volunteer');
//     const adminStr = localStorage.getItem('dashboardUser');

//     if (volunteerStr) {
//       setUser(JSON.parse(volunteerStr));
//     } else if (adminStr) {
//       setUser(JSON.parse(adminStr));
//     } else {
//       navigate('/unauthorized');
//     }
//   }, [navigate]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!user) return;
//     try {
//       // Note: Use template literals (backticks) correctly here!
//       await fetchJSON(`/api/users/${user._id}`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           password: currentPassword,
//           newPassword,
//           reset: false
//         })
//       });
//       alert('Password updated successfully');
//       const updatedUser = { ...user, firstTime: false };
//       if (user.role === 'volunteer') {
//         localStorage.setItem('volunteer', JSON.stringify(updatedUser));
//         navigate('/volunteer/dashboard');
//       } else {
//         localStorage.setItem('dashboardUser', JSON.stringify(updatedUser));
//         navigate('/admin/dashboard');
//       }
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   if (!user) return <p>Loading user data...</p>;

//   return (
//     <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-100">
//       <div className="bg-white p-6 rounded shadow-md max-w-md w-full">
//         <h2 className="text-2xl font-bold mb-4">Update Your Password</h2>
//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div>
//             <label className="block mb-1 font-medium">Current Password</label>
//             <input
//               type="password"
//               value={currentPassword}
//               onChange={e => setCurrentPassword(e.target.value)}
//               className="w-full border p-2 rounded"
//               required
//             />
//           </div>
//           <div>
//             <label className="block mb-1 font-medium">New Password</label>
//             <input
//               type="password"
//               value={newPassword}
//               onChange={e => setNewPassword(e.target.value)}
//               className="w-full border p-2 rounded"
//               required
//             />
//           </div>
//           <button type="submit" className="bg-primary text-white px-4 py-2 rounded w-full">
//             Change Password
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default UserUpdatePassword;










// dashboard-frontend/src/components/UserUpdatePassword.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchJSON } from '../api';

const UserUpdatePassword = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  useEffect(() => {
    // Check for a logged-in volunteer or admin user
    const volunteerStr = localStorage.getItem('volunteer');
    const adminStr = localStorage.getItem('dashboardUser');

    if (volunteerStr) {
      setUser(JSON.parse(volunteerStr));
    } else if (adminStr) {
      setUser(JSON.parse(adminStr));
    } else {
      navigate('/unauthorized');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;

    try {
      // If user is first time, we won't need current password (backend will check user.firstTime).
      await fetchJSON(`/api/users/${user._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          password: currentPassword,  // May be ignored if user.firstTime is true
          newPassword,
          reset: false
        })
      });

      alert('Password updated successfully');

      // Mark user as not firstTime in local storage
      const updatedUser = { ...user, firstTime: false };
      if (user.role === 'volunteer') {
        localStorage.setItem('volunteer', JSON.stringify(updatedUser));
        navigate('/volunteer/dashboard');
      } else {
        localStorage.setItem('dashboardUser', JSON.stringify(updatedUser));
        navigate('/admin/dashboard');
      }
    } catch (err) {
      alert(err.message);
    }
  };

  if (!user) {
    return <p>Loading user data...</p>;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-100">
      <div className="bg-white p-6 rounded shadow-md max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4">Update Your Password</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1 font-medium">Current Password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={e => setCurrentPassword(e.target.value)}
              className="w-full border p-2 rounded"
              placeholder="Leave blank if first-time user"
            />
          </div>
          <div>
            <label className="block mb-1 font-medium">New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              className="w-full border p-2 rounded"
              required
            />
          </div>
          <button type="submit" className="bg-primary text-white px-4 py-2 rounded w-full">
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserUpdatePassword;
